import React, { useEffect, useState, useContext } from 'react';
import { isEmpty, reduce } from 'lodash';
import { LocaleService } from '@sm360/widget-commons-core-services';
import { CheckboxGroup } from '@sm360/ui-library';
import 'trade-in/components/InstantEstimateWrapper/InstantEstimateWrapper.scss';
import 'trade-in/components/InstantEstimateWrapper/Steps/VehicleOptions/VehicleOptions.scss';
import NewTradeInContext from '../../../../NewTradeInContext.js';
import ActionButton from '../../Components/ActionButton/ActionButton.jsx';

const VehicleOptions = ({ tradeInVehicle, onPreviousStep, onNextStep, onFormSubmit }) => {
    const [selectedTradeInVehicle, setTradeInVehicle] = useState([]);
    const [availableVehicleOptions, setAvailableVehicleOptions] = useState([]);
    const { fieldsLocked } = useContext(NewTradeInContext);

    const onCheckBoxChange = (values) => {
        const selectedOptions = [];
        // To filter selected options from original trade-in props and set with selectedTradeInVehicle obj
        values.forEach((value) => {
            selectedOptions.push(selectedTradeInVehicle.options.filter((option) => value === option.code)[0]);
        });
        // set selectedVehicleOptions in tradeInVehicle obj to differenciate available options and selected options from this screen
        selectedTradeInVehicle.selectedVehicleOptions = selectedOptions;
        setTradeInVehicle(selectedTradeInVehicle);
    };

    // Send selected and previous screen trade-in option to the next screen
    const sendVehicleOptionsForm = (event) => {
        event.preventDefault();
        if (fieldsLocked) return onNextStep();

        return onFormSubmit(selectedTradeInVehicle);
    };

    // Update state with props from parent component for trade-in vehicle
    const getTradeInVehicle = (updatedVehicle) => {
        const tradeVehicle = updatedVehicle || selectedTradeInVehicle;
        const vehicleOptions = reduce(
            tradeInVehicle.options,
            (acc, result) => {
                acc.push({
                    id: result.code,
                    label: result.description,
                    value: result.description,
                    disabled: fieldsLocked,
                });
                return acc;
            },
            []
        );
        if (!isEmpty(tradeVehicle)) {
            setTradeInVehicle(tradeVehicle);
            setAvailableVehicleOptions(vehicleOptions);
        }
    };

    // Get already checked vehicle options
    // This will set the checked options if move from different screen
    const getCheckedOptions = () => {
        return selectedTradeInVehicle?.selectedVehicleOptions?.map((options) => options.code);
    };

    useEffect(() => {
        getTradeInVehicle(tradeInVehicle);
    }, []);

    return (
        <div className="vehicle-options-form">
            <h5>{LocaleService.t(`TRADE_IN.SECTIONS.VEHICLE_OPTIONS`)}</h5>
            <form className="vehicle-options-checkbox-form">
                <div className="vehicle-options-form-body">
                    {availableVehicleOptions.length > 0 ? (
                        <section className="clearfix vehicle-options-form-body--vehicle-details">
                            <p
                                className="sr-text vehicle-options-subtitle"
                                // eslint-disable-next-line react/no-danger
                                dangerouslySetInnerHTML={{
                                    __html: LocaleService.t('TRADE_IN.VEHICLE_OPTIONS.SUBTITLE'),
                                }}
                            />
                            <CheckboxGroup
                                inline
                                name="vehicleOptionsCheckboxGroup"
                                options={availableVehicleOptions}
                                onChange={(value) => onCheckBoxChange(value)}
                                checked={getCheckedOptions()}
                            />
                        </section>
                    ) : (
                        <p className="sr-text">{LocaleService.t('TRADE_IN.VEHICLE_OPTIONS.OPTIONS_NOT_AVAILABLE')}</p>
                    )}
                    <section className="clearfix vehicle-buttons-container" data-test="trade-in.vehicle-form.submit">
                        <div className="vehicle-buttons">
                            <ActionButton onClick={() => onPreviousStep()}>
                                {LocaleService.t('TRADE_IN.SECTIONS.VEHICLE_INFO')}
                            </ActionButton>
                            <ActionButton next onClick={sendVehicleOptionsForm}>
                                {LocaleService.t('TRADE_IN.SECTIONS.VEHICLE_CONDITION')}
                            </ActionButton>
                        </div>
                    </section>
                </div>
            </form>
        </div>
    );
};

VehicleOptions.displayName = 'VehicleOptions';

export default VehicleOptions;
